import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import invariant from 'invariant';
import makeModal from 'lib/makeModal';

import { removeHash } from 'util/navigation';
import MODAL_ID from './Modal.const';

export default class Modal extends PureComponent {
  static defaultProps = {
    container: null,
    standalone: false,
  };

  static propTypes = {
    shouldRender: PropTypes.bool.isRequired,
    dismissFunction: PropTypes.func.isRequired,
    container: PropTypes.object,
    onSetModalOpen: PropTypes.func.isRequired,
    onSetModalClosed: PropTypes.func.isRequired,
    onSetModalStandaloneClosed: PropTypes.func.isRequired,
    standalone: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.el = document.createElement('div');
    this.scrollHeight = 0;
  }

  componentDidMount() {
    this.modalRoot = document.getElementById(MODAL_ID);

    invariant(this.modalRoot, 'ModalRoot element should exist in DOM.');
    this.modalRoot.appendChild(this.el);

    const { dismissFunction, container, standalone, onSetModalOpen, shouldRender } = this.props;

    this.setModalListeners = makeModal({
      dismissFunction,
      container,
      closeOnClick: false,
    });

    this.rememberScroll(true);
    this.setModalListeners(true);

    if (!standalone && shouldRender) {
      onSetModalOpen();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.shouldRender === prevProps.shouldRender) {
      return;
    }
    this.setModalListeners(this.props.shouldRender);
    if (!this.props.standalone && this.props.shouldRender) {
      this.props.onSetModalOpen();
    }
  }

  componentWillUnmount() {
    invariant(this.modalRoot, 'ModalRoot element should exist in DOM.');

    const { onSetModalClosed, onSetModalStandaloneClosed, standalone } = this.props;

    this.modalRoot.removeChild(this.el);
    this.setModalListeners(false);
    onSetModalClosed();

    if (standalone) {
      onSetModalStandaloneClosed();
      removeHash();
    }

    this.rememberScroll(false);
  }

  rememberScroll = (remember) => {
    if (remember) {
      const doc = document.documentElement;
      this.scrollHeight = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
      return;
    }

    // NOTE: Using a timeout for this is questionable.
    setTimeout(() => {
      window.scrollTo(0, this.scrollHeight, { duration: 0 });
    }, 0);
  };

  render() {
    const { shouldRender } = this.props;
    if (shouldRender) {
      return ReactDOM.createPortal(this.props.children, this.el);
    }
    return null;
  }
}
